/* eslint-disable max-len */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const qualityGuidelinesService = async () => {
  return api('/api/v2/pages/?type=quality_guide.QualityGuidePage&fields=paragraphs(title,text),gallery_image_picker(image,description)', {}, 'GET');
};


export {
  qualityGuidelinesService,
};
